var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidatesIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7082 21.875V19.7917C17.7082 18.6866 17.2692 17.6268 16.4878 16.8454C15.7064 16.064 14.6466 15.625 13.5415 15.625H5.20817C4.1031 15.625 3.04329 16.064 2.26189 16.8454C1.48049 17.6268 1.0415 18.6866 1.0415 19.7917V21.875",
    stroke: "#ffffff",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37516 11.4583C11.6764 11.4583 13.5418 9.59285 13.5418 7.29167C13.5418 4.99048 11.6764 3.125 9.37516 3.125C7.07398 3.125 5.2085 4.99048 5.2085 7.29167C5.2085 9.59285 7.07398 11.4583 9.37516 11.4583Z",
    stroke: "#ffffff",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9585 21.875V19.7917C23.9578 18.8685 23.6505 17.9717 23.0849 17.242C22.5193 16.5124 21.7274 15.9912 20.8335 15.7604",
    stroke: "#ffffff",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 3.26044C17.5628 3.48992 18.3572 4.01117 18.9245 4.74201C19.4918 5.47285 19.7997 6.37172 19.7997 7.29689C19.7997 8.22207 19.4918 9.12094 18.9245 9.85178C18.3572 10.5826 17.5628 11.1039 16.6665 11.3334",
    stroke: "#ffffff",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatesIc);
export default __webpack_public_path__ + "static/media/candidates-ic.d0dd63f411e4f5e7a84bbbfe0c718ae5.svg";
export { ForwardRef as ReactComponent };